import {CarteraInterface} from "../models/cartera.interface";

export namespace PaginationAction {

  export class FetchPagination {

    static readonly type = '[PaginationAction] Fetch pagination';
    constructor(public pagination: any) {}
    //constructor(public hideLoading = false, public id = null) {} 
  }

  export class FetchData {

    static readonly type = '[DataAction] Fetch data';
    constructor(public data: any) {}
    
  }

}
